import type { QuizChartData, WeightUnit } from "../types/upsell.types";

export const formatWeightValue = (weight: number, unit: WeightUnit) => {
  if (!Number.isFinite(weight)) {
    return unit === "kg" ? "0kg" : "0lb";
  }

  return `${Math.round(weight)}${unit}`;
};

export const replaceGoalWeightToken = (
  text: string,
  chartData: QuizChartData | null,
) => {
  if (!chartData || !text.includes("###goal_weight###")) {
    return text;
  }

  return text.replaceAll(
    "###goal_weight###",
    formatWeightValue(chartData.goalWeight, chartData.unit),
  );
};
